import { useState } from "react";
import { axiosInstance } from "../context/axiosInstance";
import { useUserContext } from "../context/userContext";

export const getTokenFromLS = (): string => {
	return localStorage.getItem("token") as string;
};

export function useToken() {
	const {
		actions: { setUserLogged },
	} = useUserContext();
	const [token, setToken] = useState(getTokenFromLS());

	const saveUserData = (userToken: any) => {
		localStorage.setItem("userMESData", JSON.stringify(userToken));
		localStorage.setItem("refreshToken", userToken["refreshToken"]);
		localStorage.setItem("token", userToken["token"]);
		setToken(userToken["token"]);
		axiosInstance.defaults.headers.Authorization = `Bearer ${userToken["token"]}`;
		setUserLogged(true);
	};

	const clearUserData = () => {
		localStorage.removeItem("userMESData");
		localStorage.removeItem("token");
		localStorage.removeItem("refreshToken");
		setToken("");
		setUserLogged(false);
	};
	const getUserName = () => {
		const sessionData = localStorage.getItem("userMESData");
		const userData = JSON.parse(<string>sessionData);
		return (userData || {}).username || "";
	};
	const getFirstName = () => {
		const sessionData = localStorage.getItem("userMESData");
		const userData = JSON.parse(<string>sessionData);
		return (userData || {}).firstName || "";
	};
	const getLastName = () => {
		const sessionData = localStorage.getItem("userMESData");
		const userData = JSON.parse(<string>sessionData);
		return (userData || {}).lastName || "";
	};
	const getUserId = () => {
		const sessionData = localStorage.getItem("userMESData");
		const userData = JSON.parse(<string>sessionData);
		setUserLogged(true);
		return (userData || {}).id || -1;
	};
	const hasPermission = (permissionId: number) => {
		const sessionData = localStorage.getItem("userMESData");
		if (sessionData === undefined) return false;
		const userData = JSON.parse(<string>sessionData);
		const permissions = userData.permissions || [];
		return permissions.indexOf(permissionId) > -1; //case sensitve
	};

	return {
		getUserName,
		saveUserData,
		clearUserData,
		getFirstName,
		getLastName,
		getUserId,
		hasPermission,
		token,
	};
}
